import {Stack, Typography, Box} from '@mui/material';
import {useClient} from '../../../../context/ClientContext';
import StepsHeading from '../../common/StepsHeading';

export default function Step1_Gender({userData, setUserData, onNext}) {
  const {theme} = useClient();

  // Handle option selection and set genderId directly
  const handleOptionSelect = (field, value) => {
    let genderId = '';
    switch (value) {
      case 'male':
        genderId = 1;
        break;
      case 'female':
        genderId = 2;
        break;
      case 'Non-binary':
        genderId = 3;
        break;
      case 'Prefer not to say':
        genderId = 4;
        break;
      default:
        break;
    }

    setUserData({
      ...userData,
      [field]: value,
      genderId,
    });

    // Call onNext directly after setting values
    onNext();
  };

  return (
    <Stack
      spacing={2}
      sx={{
        width: '100%',
        maxWidth: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <StepsHeading title="Are you..." />
      {[
        {label: 'Female', value: 'female'},
        {label: 'Male', value: 'male'},
        {label: 'Non-binary', value: 'Non-binary'},
        {label: 'Prefer not to say', value: 'Prefer not to say'},
      ].map((option, index) => (
        <Box
          key={index}
          onClick={() => handleOptionSelect('gender', option.value)}
          sx={{
            width: {
              xs: '280px',
              sm: '300px',
              md: '400px',
              lg: '450px',
            },
            maxWidth: '100%',
            height: {
              xs: '44px',
              md: '54px',
            },
            backgroundColor: userData.gender === option.value ? theme.primaryColor : 'rgba(26, 26, 26, 0.08)',
            marginBottom: '10px',
            borderRadius: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            color: userData.gender === option.value ? 'white' : '#000',
            '&:hover': {
              transform: 'scale(1.02)',
              color: 'white',
              backgroundColor: theme.primaryColor,
            },
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: '14px',
                sm: '16px',
                md: '18px',
              },
              fontWeight: '400',
            }}
          >
            {option.label}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
}
